import { Route, Routes } from 'react-router-dom';

import { PrivateRoute } from './PrivateRoute';
import { routes } from './routes';

export const Router = () => (
  <Routes>
    {Object.entries(routes).map(([routeKey, route]) =>
      route.private ? (
        <Route key={routeKey} path={route.url} element={<PrivateRoute roles={route.roles}>{route.component}</PrivateRoute>} />
      ) : (
        <Route key={routeKey} path={route.url} element={route.component} />
      ),
    )}
  </Routes>
);
